import apiConf from '@/config/api'
import baseConfig from '@/config/baseConfig'
import envConfig from '@/config/envConfig'
import { supreme } from '@/supreme-core'
import hybrid, { getUserInfo } from '@/util/nativeHybrid'
import dayjs from 'dayjs'
import nativeHybrid from '@/util/nativeHybrid'

export default {
	isOfflinePackage() {
		return window.location.protocol === 'file:'
	},
	getEnv() {
		if (!this.isInWebview() && location.href.indexOf('localhost:80') >= 0) {
			return baseConfig.localConfiguration.env
		}
		// 0 qa 1 uat 2 stg 3 prod
		var url = location.href
		var code = 3
		//return 1;
		if (location.protocol == 'file:') {
			var osInfo
			try {
				osInfo = hybrid.getAppInfo()
			} catch (e) {
				code = 3
			}
			if (osInfo && osInfo.env) {
				if (osInfo.env == 'qa') {
					code = 0
				} else if (osInfo.env === 'sit' || osInfo.env === 'uat' || osInfo.env === 'test') {
					code = 1
				} else if (osInfo.env === 'stg') {
					code = 2
				} else {
					code = 3
				}
			}
			return code
		}
		if (location.href.indexOf('localhost') >= 0 || location.href.indexOf(':8080') >= 0) {
			return 1
		}
		if (
			url.indexOf('-qa.') != -1 ||
			url.indexOf('-dev') != -1 ||
			url.indexOf('localhost') != -1 ||
			url.indexOf('127.0.0.1') != -1
		) {
			code = 0
		} else if (
			url.indexOf('-uat.') != -1 ||
			url.indexOf('-sit.') != -1 ||
			url.indexOf('-test.') != -1
		) {
			code = 1
		} else if (url.indexOf('-stg.') != -1) {
			code = 2
		} else {
			code = 3
		}

		return code
	},
	// 获取数据请求的env 数据
	getEnvInfo(name) {
		let env = apiConf[name] || apiConf['defaultConfig']
		switch (this.getEnv()) {
			case 0:
				return env.qa
			case 1:
				return env.uat
			case 2:
				return env.stg
			case 3:
				return env.prod
			default:
				return env.qa
		}
	},
	// 获取纯和环境相关的数据
	getBaseEnvInfo() {
		switch (this.getEnv()) {
			case 0:
				return envConfig.qa
			case 1:
				return envConfig.uat
			case 2:
				return envConfig.stg
			case 3:
				return envConfig.prod
			default:
				return envConfig.qa
		}
	},

	getEnvStr() {
		switch (this.getEnv()) {
			case 0:
				return 'qa'
			case 1:
				return 'sit'
			case 2:
				return 'stg'
			case 3:
				return 'prod'
			default:
				return 'qa'
		}
	},
	getFormattedEnvStr() {
		const envMap = {
			qa: 'dev',
			uat: 'test',
			sit: 'test',
			stg: 'stg',
			prod: 'prod'
		}
		return envMap[this.getEnvStr()] || 'prod'
	},
	/**
	 * 路由前缀
	 */
	envPath() {
		let envInfo = this.getBaseEnvInfo()
		let pathName = baseConfig.compatible.isSupportHybrid
			? baseConfig.compatible.prefix + baseConfig.compatible.module
			: ''
		return `${envInfo.openUrl}${pathName}`
	},
	// 是否在app 的webview 中，浏览器，微信，微博等载体不算
	isInWebview() {
		return nativeHybrid.isInWebview()
	},

	checkLogin() {
		return new Promise((resolve, reject) => {
			if (!this.isInWebview()) {
				return reject()
			}
			if (!!this.isToken()) {
				return resolve()
			}
			nativeHybrid.openLoginPage(resolve)
		})
	},
	getWindowScrollTop() {
		return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
	},
	isToken() {
		return this.getToken() ? true : false
	},

	getToken() {
		if (!this.isInWebview() && location.href.indexOf('localhost:80') >= 0) {
			return baseConfig.localConfiguration.token
		}

		if (hybrid.isWeapp() && location.href.indexOf('localhost:80')) {
			return baseConfig.localConfiguration.token
		}
		let userToken = getUserInfo()
		return userToken && userToken['access_token']
	},
	formatCurrency(price) {
		if (typeof price !== 'number') {
			return price
		}
		return price.toLocaleString && price.toLocaleString() ? price.toLocaleString() : price
	},
	formatDate(date, format = 'YYYY/MM/DD') {
		if (!date) {
			return ' '
		}
		return dayjs(date).format(format)
	},
	formatBigNumber(num) {
		if (typeof num !== 'number') {
			return num
		}
		return num.toLocaleString && num.toLocaleString() ? num.toLocaleString() : num
	},
	formatAge(age) {
		const year = Math.floor(age / 12)
		const mon = age % 12

		return year ? `${year}年${mon}个月` : `${mon}个月`
	},
	formatMileage(mileage) {
		if (typeof mileage !== 'number') {
			mileage = +mileage
		}

		if (mileage > 1000) {
			return (mileage / 10000).toFixed(1) + '万公里'
		}

		return mileage + '公里'
	},
	scrollIntoView(el, align = 'none') {
		if (align === 'left' || align === 'right') {
			const totalWidth = el.parentElement.scrollWidth
			const clientLeft = el.offsetLeft
			const viewportWidth = el.parentElement.clientWidth
			const contentWidth = el.getBoundingClientRect().width

			if (align === 'left') {
				// 是否足以滚动到最左边
				if (clientLeft + viewportWidth < totalWidth) {
					el.parentElement.scrollTo({ left: clientLeft })
				} else {
					// 不足以滚动到最左边,则滚动到右
					el.parentElement.scrollTo({ left: totalWidth - viewportWidth })
				}
			} else {
				// 是否足以滚动到最右边
				if (clientLeft + contentWidth > viewportWidth) {
					el.parentElement.scrollTo({
						left: clientLeft + contentWidth - viewportWidth
					})
				} else {
					// 不足以滚动到最右,则滚动到最左
					el.parentElement.scrollTo({ left: 0 })
				}
			}
		} else {
			if (el.scrollIntoViewIfNeeded) {
				el.scrollIntoViewIfNeeded(false)
			} else {
				el.scrollIntoView()
			}
		}
	},

	getQueryString(...args) {
		return supreme.getQueryString(...args)
	}
}
